import * as React from "react"

import {
  cn
} from "@/lib/utils"

export interface InputProps
    extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({
  className, type, ...props 
}, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "border-input bg-background focus_border-primary file_border-0 file_text-foreground placeholder_text-muted-foreground file_bg-transparent file_text-sm file_font-medium disabled_cursor-not-allowed disabled_opacity-50 flex h-[50px] w-full border px-3 py-2 text-sm outline-none transition-all duration-300",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})

Input.displayName = "Input"

export {
  Input
}

